import { render, staticRenderFns } from "./user-info-navbar.vue?vue&type=template&id=5dc318e5&scoped=true&"
import script from "./user-info-navbar.vue?vue&type=script&lang=ts&"
export * from "./user-info-navbar.vue?vue&type=script&lang=ts&"
import style0 from "./user-info-navbar.vue?vue&type=style&index=0&id=5dc318e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc318e5",
  null
  
)

export default component.exports